/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type PatchAIConfigVariationsBulkPathParams = NonNullable<
  operations['patchAIConfigVariationsBulk']['parameters']['path']
>;

export type PatchAIConfigVariationsBulkRequestBody = OperationRequestBodyContent<
  operations['patchAIConfigVariationsBulk']
>;

export interface Input extends PatchAIConfigVariationsBulkPathParams {
  apiVersion?: string;
  body: PatchAIConfigVariationsBulkRequestBody;
}

export async function patchAIConfigVariationsBulk(
  { apiVersion, body, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().PATCH('/internal/projects/{projectKey}/ai-configs/{configKey}/variationsBulk', {
    params: { path },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
